import { action, IObservableValue, observable } from 'mobx';
import { MapCoordinates } from '../../Map/interfaces/MapCoordinates';
export class SaveStateMapStore {
    @observable center: IObservableValue<number[]>;
    @observable selectedObject: IObservableValue<any>;
    @observable zoom: IObservableValue<number | null>;
    @observable mapId: IObservableValue<string | null>;
    @observable layerId: IObservableValue<string | null>;
    @observable lines: IObservableValue<MapCoordinates[]>;
    @observable points: IObservableValue<MapCoordinates[]>;
    @observable polygons: IObservableValue<MapCoordinates[]>;
    @observable selectedTile: IObservableValue<string | null>;
    @observable showSelectedObject: IObservableValue<boolean>;
    @observable searchString: IObservableValue<string | null>;
    @observable foundAddressId: IObservableValue<number | null>;
    @observable opacityMap: IObservableValue<Map<string, number> | null>;

    constructor() {
        this.center = observable.box<number[]>([]);
        this.selectedTile = observable.box<any>(null);
        this.zoom = observable.box<number | null>(null);
        this.selectedObject = observable.box<any>(null);
        this.mapId = observable.box<string | null>(null);
        this.lines = observable.box<MapCoordinates[]>([]);
        this.layerId = observable.box<string | null>(null);
        this.points = observable.box<MapCoordinates[]>([]);
        this.polygons = observable.box<MapCoordinates[]>([]);
        this.searchString = observable.box<string | null>(null);
        this.showSelectedObject = observable.box<boolean>(false);
        this.foundAddressId = observable.box<number | null>(null);
        this.opacityMap = observable.box<Map<string, number> | null>(null);
    }

    @action('set map id')
    setMapId = (mapId: string | null) => {
        this.mapId.set(mapId);
    }

    @action('get map id')
    getMapId = (): string | null => {
        return this.mapId.get();
    }

    @action('set search string')
    setSearchString = (searchString: string | null) => {
        this.searchString.set(searchString);
    }

    @action('get search string')
    getSearchString = (): string | null => {
        return this.searchString.get();
    }

    @action('set found address id')
    setFoundAddressId = (foundAddressId: number | null) => {
        this.foundAddressId.set(foundAddressId);
    }

    @action('get found address id')
    getFoundAddressId = (): number | null => {
        return this.foundAddressId.get();
    }

    @action('set layer id')
    setLayerId = (layerId: string | null) => {
        this.layerId.set(layerId);
    }

    @action('get layer id')
    getLayerId = (): string | null => {
        return this.layerId.get();
    }

    @action('set selected object')
    setSelectedObject = (selectedObject: any) => {
        this.selectedObject.set(selectedObject);
    }

    @action('get selected object')
    getSelectedObject = (): any => {
        return this.selectedObject.get();
    }

    @action('set zoom')
    setZoom = (zoom: number | null) => {
        this.zoom.set(zoom);
    }

    @action('get zoom')
    getZoom = (): number | null => {
        return this.zoom.get();
    }

    @action('set show selected object')
    setShowSelectedObject = (show: boolean) => {
        this.showSelectedObject.set(show);
    }

    @action('get show selected object')
    getShowSelectedObject = (): boolean => {
        return this.showSelectedObject.get();
    }

    @action('set selected tile')
    setSelectedTile = (selectedTile: string | null) => {
        this.selectedTile.set(selectedTile);
    }

    @action('get selected tile')
    getSelectedTile = (): string | null => {
        return this.selectedTile.get();
    }

    @action('set polygons')
    setPolygons = (polygons: MapCoordinates[]) => {
        this.polygons.set(polygons);
    }

    @action('get polygons')
    getPolygons = (): MapCoordinates[] => {
        return [...this.polygons.get()];
    }

    @action('set lines')
    setLines = (lines: MapCoordinates[]) => {
        this.lines.set(lines);
    }

    @action('get lines')
    getLines = (): MapCoordinates[] => {
        return this.lines.get();
    }

    @action('set points')
    setPoints = (points: MapCoordinates[]) => {
        this.points.set(points);
    }

    @action('get points')
    getPoints = (): MapCoordinates[] => {
        return this.points.get();
    }

    @action('set center')
    setCenter = (center: number[]) => {
        this.center.set(center);
    }

    @action('get center')
    getCenter = (): number[] => {
        return this.center.get();
    }

    @action('set opacity map')
    setOpacityMap = (opacityMap: Map<string, number> | null) => {
        this.opacityMap.set(opacityMap);
    }

    @action('get opacity map')
    getOpacityMap = (): Map<string, number> | null => {
        return this.opacityMap.get();
    }
}

const saveStateMapStore = new SaveStateMapStore();

export default saveStateMapStore;
